import { APP_INITIALIZER, makeEnvironmentProviders, Type } from '@angular/core';
import { OAuthErrorEvent } from 'angular-oauth2-oidc';
import { filter } from 'rxjs/operators';
import { ConsoleErrorAppenderService } from './console-error-appender.service';
import { ERROR_APPENDERS, ErrorAppenderService } from './error-appender.service';
import { errorEventChannelProviders, ErrorEventChannelService } from './error-event-channel.service';
import { ErrorLoggerService } from './error-logger.service';
import { ErrorLoggingModuleConfig } from './error-logging-module.config';
import { ERROR_SELECTOR_FUNC_ARRAY } from './error-selector-func-token';
import { ngErrorHandlerProvider } from './ng-error-handler';

export function configureErrorHandler(
  errorEventChannelService: ErrorEventChannelService,
  errorLoggerService: ErrorLoggerService
) {
  return () =>
    errorEventChannelService.errors$
      // To avoid OAuth error log again
      .pipe(filter(e => !(e instanceof OAuthErrorEvent)))
      .subscribe(error => errorLoggerService.log(error));
}

export function provideErrorLogging(config: ErrorLoggingModuleConfig = {}) {
  const appenders: Type<ErrorAppenderService>[] = [ConsoleErrorAppenderService, ...(config.additionalAppenders ?? [])];
  return makeEnvironmentProviders([
    ngErrorHandlerProvider,
    errorEventChannelProviders,
    appenders.map(appender => ({
      provide: ERROR_APPENDERS,
      useExisting: appender,
      multi: true
    })),
    ErrorLoggerService,
    {
      provide: APP_INITIALIZER,
      useFactory: configureErrorHandler,
      deps: [ErrorEventChannelService, ErrorLoggerService],
      multi: true
    },
    config.selectors
      ? [
          {
            provide: ERROR_SELECTOR_FUNC_ARRAY,
            useValue: config.selectors
          }
        ]
      : []
  ]);
}
